import { ASSETS } from "@/data/content";
import { useSite } from "@/context/SiteContext";

export default function Sprig({ className = "" }) {
  const { img } = useSite();
  return (
    <img
      src={img("sprig", ASSETS.sprig)}
      alt=""
      aria-hidden="true"
      className={`inline-block select-none pointer-events-none object-contain ${className}`}
    />
  );
}
